import { render, staticRenderFns } from "./RespostaCadastroConfirmacao.vue?vue&type=template&id=a2dac6a0"
import script from "./RespostaCadastroConfirmacao.vue?vue&type=script&lang=js"
export * from "./RespostaCadastroConfirmacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports